import tw, { styled, css } from 'twin.macro';
import { StyledProps as Props } from '../../types/util.types';

export const wrapper = styled.div<Props>(({ company }) => [
  css`
    ${tw`px-6 font-semibold text-white text-14 leading-22 bg-blue`};
  `,
  company && tw`text-gray2 bg-transparent	`
]);
